/**
 * Custom Button — Frontend script (view.js)
 *
 * Loaded on the frontend only when the block is present on the page
 * (registered via "viewScript" in block.json).
 *
 * The button works without JavaScript — this file only adds progressive
 * enhancements. Adjust or remove as needed.
 */
(function () {
	"use strict";

	function init() {
		const buttons = document.querySelectorAll(".prudential-button");

		buttons.forEach((button) => {
			// Harden external links.
			if (button.hostname && button.hostname !== window.location.hostname) {
				button.setAttribute("rel", "noopener noreferrer");
			}

			// Example enhancement: a "pressed" class for CSS transitions.
			button.addEventListener("mouseenter", () => {
				button.classList.add("prudential-button-hovered");
			});
			button.addEventListener("mouseleave", () => {
				button.classList.remove("prudential-button-hovered");
			});
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
